import React, { useCallback } from "react"
import ReactDOM from "react-dom"
import {
  motion,
  useMotionValue,
  useTransform,
  AnimatePresence,
} from "framer-motion"
import Topnav from "@/components/topnav"
import useOrientation from "@/hooks/useOrientation"
import imgInstall from "/image/app/sistema/QR.webp"

type Props = {
  isVisible: boolean
  content?: React.ReactNode
  setIsVisible: (value: boolean) => void
}

const QrModal: React.FC<Props> = ({
  isVisible,
  content,
  setIsVisible,
}) => {
  const { isPortrait, isLandscape, isStandalone, isDesktopStandalone } = useOrientation()
  const x = useMotionValue(0)
  const y = useMotionValue(0)

  const rotateX = useTransform(y, [-100, 100], [30, -30])
  const rotateY = useTransform(x, [-100, 100], [-30, 30])

  const handleCloseModal = useCallback(() => {
    setIsVisible(false)
  }, [setIsVisible])

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isVisible && (
        <motion.div
          onClick={handleCloseModal}
          className="
            fixed
            inset-0
            z-[98]
            flex
            items-center
            justify-center
            backdrop-blur-[45px]
          "
          role="dialog"
          aria-modal="true"
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0, transition: { duration: 0.2 } }}
        >
          <motion.div
            drag
            dragElastic={0.56}
            dragMomentum={false}
            dragConstraints={{ top: 0, left: 0, right: 0, bottom: 0 }}
            style={{ x, y, rotateX, rotateY }}
            onClick={(e) => e.stopPropagation()}
            className="
              cursor-grab
              active:cursor-grabbing
              bg-black
              rounded-2xl
              overflow-hidden
              max-w-[15rem]
              w-full
              shadow-2xl
            "
          >
            {/* IMAGE */}
            <div className="flex justify-center">
              <img
                src={imgInstall}
                alt="QR Mixtape"
                className="
                  w-full
                  max-w-[240px]
                  rounded-2xl
                  object-cover
                "
              />
            </div>

            {/* CONTENT */}
            <div className="text-center">{content}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  )
}

export default QrModal